module.exports = __webpack_public_path__ + "static/media/ce1fb512.jpg";